import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import Slider from "react-slick";
import styles from "./MultiScroll.module.css";
import { MultiScrollSettings } from "./MultiScrollSettings";
import Button from "../../components/Button";
import Link from "next/link";
import { useSelector } from "react-redux";
import { gotoNext, gotoPrev } from "@/helper/sliderControls";
import left from "../../assets/icons/left-circle-button.svg";
import right from "../../assets/icons/right-circle-button.svg";
import { removeStorage } from "@/utils/storage";
import { setPostAcademicInfo, setSchoolLogo } from "@/redux/dataSlice";
import { useDispatch } from "react-redux";

export const MultiScroll = (props) => {
  const customSlider = useRef(null);
  const dispatch = useDispatch();

  const { data, bgColor, color } = props;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [displayPopup, setDisplayPopup] = useState(false);
  const { isMobileDevice } = useSelector((state: any) => state.data);

  useEffect(() => {
    document.documentElement.style.setProperty('--button-bg-color', color);
  }, [color]);

  useEffect(() => {
    document.documentElement.style.setProperty('--div-bg-color', bgColor);
  }, [bgColor]);

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
  };

  const totalSlides = data?.length;
 

  const baseURL = window.location.origin;

  const handleEnrollment =(path) =>{

      removeStorage('currentStep');
      dispatch(setPostAcademicInfo(null));
      dispatch(setSchoolLogo(null));
      window.open(`${baseURL}/education${path}`, "_blank", "noopener noreferrer");
};
  return (
    <>
    {data && (
    <div
      className="container multiscroll-sec"
      data-testid="multiscroll-container-id"
    >
      <div className="slider-container multiscroll school_content_pd">
        <Slider {...MultiScrollSettings}
          beforeChange={handleBeforeChange}
          ref={customSlider}
        >
          {data?.map((item, index) => (
            <div key={index}>
              {item?.icon?.results?.length > 0 &&
                item?.icon?.results?.[0]?.fileUrl !== null &&
                item?.subtitle === null && (
                  <div
                    className={` ${styles.multSlider}  ${styles.multSliderbg}`}
                  >
                    <Image
                      src={item?.icon?.results?.[0]?.fileUrl}
                      alt="slider"
                      width={128}
                      height={128}
                      sizes="(max-width: 768px) 100vw, (max-width: 560px) 50vw, 33vw"
                    />
                    <div className={`row ${styles.overlayText}`}>
                      <h3>{item?.title}</h3>
                    </div>
                  </div>
                )}
              {item?.subtitle !== null && (
                <div
                  className={`bg-green-slide ${styles.multSlider} ${styles.multSliderbg}  ${styles.multSliderbggr}`}
                >
                  <Image
                    src={item?.icon?.results?.[0]?.fileUrl}
                    alt="slider"
                    width={128}
                    height={128}
                    sizes="(max-width: 768px) 100vw, (max-width: 560px) 50vw, 33vw"
                  />

                  <div className={`row ${styles.overlayText}`}>
                    <h3>{item?.title}</h3>
                 
                    <Button
                      data-testid="button-id"
                      className={` ${styles.greenButton}`}
                      // onClick={()=>setDisplayPopup(true)}
                    >
                      {typeof item?.hyperlink === "string" ? (
                        <Link href={item.hyperlink} legacyBehavior>
                          <a
                            onClick={
                              item?.subtitle === "Start enrolment" && 
                              item?.hyperlink &&
                              !item.hyperlink.startsWith("https")
                                ? (e) => {
                                    e.preventDefault();
                                    handleEnrollment(item.hyperlink);
                                  }
                                : undefined
                            }
                            target={item?.externallink ? "_blank" : "_self"}
                            rel={
                              item?.externallink
                                ? "noopener noreferrer"
                                : undefined
                            }
                          >
                            {item?.subtitle}
                          </a>
                        </Link>
                      ) : (
                        item?.subtitle
                      )}
                    </Button>
                  </div>
                </div>
              )}
              {item?.icon?.results?.length === 0 && item?.subtitle === null && (
                <div className={` ${styles.multSlider}`}>
                  <Image
                    src={item?.image?.results?.[0]?.fileUrl}
                    alt="slider"
                    width={260}
                    height={560}
                    // placeholder="blur"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                  <div className={`${styles.overlay}`}></div>
                  <div className={`row ${styles.overlayText}`}>
                    <h3>{item?.title}</h3>
                  </div>
                </div>
              )}
            </div>
          ))}
        </Slider>

        {
          isMobileDevice && (
            <div
              className={`${styles.btn_scroll_wp
                }`}
            >
              <button
                onClick={() => gotoPrev(customSlider)}
                disabled={currentSlide === 0}
                className={currentSlide === 0 ? styles.disabledButton : ""}
                data-testid="btn-prev"
              >
                <Image
                  src={left}
                  alt="previous"
                  width={24}
                  height={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </button>
              <button
                onClick={() => gotoNext(customSlider)}
                disabled={currentSlide + 1 === totalSlides - 1}
                className={
                  currentSlide + 1 === totalSlides - 1 ? styles.disabledButton : ""
                }
                data-testid="btn-next"
              >
                <Image
                  src={right}
                  alt="next"
                  width={24}
                  height={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </button>
            </div>
          )}

      </div>
    </div>
    )}
    </>
  );
};

export default MultiScroll;
